import { styled, Text } from '@zeiss/beyond-online-react';
import { PropsWithChildren } from 'react';

const StyledSectionText = styled(Text)`
  /* Override margin to match designs */
  margin: 0;
`;

export const SectionText = ({ children }: PropsWithChildren) => (
  <StyledSectionText size="xs">{children}</StyledSectionText>
);
